export enum UI_ROUTES {
  Home = '/',
  Vegas = '/vegas'
}
